import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {IPermissionSchema} from "../components/interfaces/permissionschema";
import { AuthenticationService } from '@ispm/user/services/authentication.service';

@Injectable()
export class PermissionSchemaService {

  public static baseUrl: string = '/permissionSchemas';
  permissionschemas: IPermissionSchema[] = [];
  constructor(
    protected _http: HttpInterceptorService,
    private authService: AuthenticationService,
  ) {
  }


  public getPermissionSchemas() {
    if (this.permissionschemas && this.permissionschemas.length > 0) {
      // Data already exists, no need to fetch again
      return Observable.of(this.permissionschemas);
    }
    const req = this._http.get("/permissionSchemas"+"/"+this.authService.user.organization).
      map((response) => {
      this.permissionschemas = response.json();
      this.permissionschemas.sort((a, b) => a.name.localeCompare(b.name));
      return this.permissionschemas;
      }).
      map((data) => {
      this.permissionschemas = data;
      return this.permissionschemas;
     }).
      catch(err => {
        return Observable.throwError(err);
      }).publish()
    ;

    req.connect();

    return req;
  }
  public resetLocalCache(){
    this.permissionschemas = [];
  }

  public readPermissionSchema(id){
    const req = this._http.get("/permissionSchemas"+"/"+this.authService.user.organization+ '/' + id).
      map((response) => {
        return response.json();
      }).
      map((data) => {
         return data;
      }).
      catch(err => {
        return Observable.throwError(err);
      }).publish()
    ;
    req.connect();
    return req;
  }

  public createPermissionSchema(permissionSchemaToCreate) {
    const req = this._http.post(PermissionSchemaService.baseUrl + '/' + this.authService.user.organization, permissionSchemaToCreate).map((response) => {
        this.permissionschemas.push(response.json());
        this.permissionschemas.sort((a, b) => a.name.localeCompare(b.name));
        return response.json();
      }).map((data) => {
        return data;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish()
    ;
    req.connect();
    return req;
  }

  public updatePermissionSchema (permissionSchemaToUpdate, prevPermissionSchemName) {
      const req = this._http.put(PermissionSchemaService.baseUrl + '/' + this.authService.user.organization + '/' + permissionSchemaToUpdate.id, permissionSchemaToUpdate).map((response) => {
      var index = this.findWithAttr(this.permissionschemas, 'id', prevPermissionSchemName);
      if (index > -1)
        this.permissionschemas.splice(index, 1);
        this.permissionschemas.push(response.json());
        this.permissionschemas.sort((a, b) => a.name.localeCompare(b.name));
        return response.json();
      }).map((data) => {
        return data;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish()
    ;
    req.connect();
    return req;
  }

  public deletePermissionSchema(permissionSchemaId: any) {
    const req = this._http.delete(PermissionSchemaService.baseUrl + '/' + this.authService.user.organization + '/' + permissionSchemaId).map((response) => {
        var index = this.findWithAttr(this.permissionschemas, 'id', permissionSchemaId);
        if (index > -1)
          this.permissionschemas.splice(index, 1);
          this.permissionschemas.sort((a, b) => a.name.localeCompare(b.name));
        return true;
      }).catch(err => {
        if(err.status == 400 && err.error == null ) {
          err.error = "A Role using this Permission schema exist, therefore it cannot be deleted";
        }
        return Observable.throwError(err);
      }).publish()
    ;
    req.connect();
    return req;
  }

  findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }
}
